import { useMemo, useState } from "react";

import "./SearchSelect.css";

export default function SearchSelect({
  label,
  value,
  options = [],
  onChange,
  placeholder = "Zoeken...",
  disabled = false,
  error = "",
}) {
  const [search, setSearch] = useState("");

  const selectedOption = options.find((option) => option.value === value);

  const filteredOptions = useMemo(() => {
    const term = search.trim().toLowerCase();

    if (!term) return options;

    return options.filter((option) =>
      option.label.toLowerCase().includes(term),
    );
  }, [options, search]);

  return (
    <div className="search-select">
      {label && <label>{label}</label>}

      <div className="search-select__box">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          disabled={disabled}
          placeholder={selectedOption ? selectedOption.label : placeholder}
        />

        <div className="search-select__list">
          {filteredOptions.length === 0 ? (
            <div className="search-select__empty">Geen resultaten</div>
          ) : (
            filteredOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                disabled={disabled}
                className={
                  value === option.value ? "search-select__active" : ""
                }
                onClick={() => {
                  onChange(option.value);
                  setSearch(option.label);
                }}
              >
                {option.label}
              </button>
            ))
          )}
        </div>
      </div>

      {error && <span className="search-select__error">{error}</span>}
    </div>
  );
}
